import React, { useEffect } from 'react'
import "./Home.css"
const Home = () => {
 const scrollDown = () => {
  window.scrollTo({
    top: 1000,
    behavior: "smooth",
  });
};
useEffect(()=>{
 window.scrollTo(0,0)
},[])
  return (
    <>
    {/* ----------- hero section ------------ */}
  <section className='lending-hero'>
    <article className='lending-hero-gap'>
        <div className='lending-texts'>
            <h1 className='lending-head-text'>Building a Community Driven<br /> Global Ecosystem</h1>
            <p className='lending-sub-text'>Connecting people, enterprises, and institutions through a unified digital platform <br />to drive sustainable growth and large-scale impact.</p>
            <button className="cta-btn" onClick={scrollDown}>
              <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Mouse body */}
                <rect x="2" y="2" width="20" height="28" rx="10" stroke="currentColor" strokeWidth="2" fill="none"/>
                {/* Mouse scroll wheel with animation */}
                <line x1="12" y1="8" x2="12" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="scroll-line"/>
              </svg>
              Scroll Down
            </button>
        </div>
    </article>
  </section>
  {/* ============== cients section ================== */}
  
    </>
  )
}

export default Home